/**
 * usePracticeStatistics Hook
 * Fetches detailed practice statistics for the My Rituality dashboard
 */

import { useQuery } from "@tanstack/react-query"
import { getPracticeStatistics } from "../services/my-rituality.service"

export function usePracticeStatistics(userId: string) {
  return useQuery({
    queryKey: ["practiceStatistics", userId],
    queryFn: () => getPracticeStatistics(userId),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}
